import { IInlineNotification, Typography } from '@sanlam-glacier/app-common/components';
import { Block, Grid } from '@sanlam-glacier/app-common/modules/grid';
import InlineNotificationCenterIcon from 'components/molecules/inline-notification-center-icon/InlineNotificationCenterIcon';

interface InlineBannerProps {
  message?: string;
  heading?: string;
  body?: React.ReactNode;
  className?: string;
  status?: IInlineNotification['status'];
  spacing?: IInlineNotification['spacing'];
}

export const InlineBanner = ({
  message,
  className,
  status,
  heading,
  body,
  spacing
}: InlineBannerProps) => {
  return (
    <Grid row className={className}>
      <Block sm={12}>
        <InlineNotificationCenterIcon
          spacing={spacing}
          status={status}
          headerText={
            heading && body ? (
              <>
                <Typography variant={Typography.VARIANT.B3}>{heading}</Typography>
                <Typography variant={Typography.VARIANT.B3} color={Typography.COLOR.SECONDARY}>
                  {body}
                </Typography>
              </>
            ) : (
              <Typography variant={Typography.VARIANT.B3}>{message}</Typography>
            )
          }
        />
      </Block>
    </Grid>
  );
};
